export interface BehaviorAssistantRationaleWorkScheduleRow { 
  text: string; 
  alignment: string 
}

type BehaviorAssistantRationaleHeaderCell = {
  text: string;
  bold: boolean;
  alignment: string;
};

type BehaviorAssistantRationalePdfCell =
  | BehaviorAssistantRationaleHeaderCell
  | BehaviorAssistantRationaleWorkScheduleRow;

export class BehaviorAssistantRationaleWorkSchedule {
  table_headers: BehaviorAssistantRationaleHeaderCell[];
  table_rows: BehaviorAssistantRationaleWorkScheduleRow[][];

  constructor(data?: Partial<BehaviorAssistantRationaleWorkSchedule>) {
    this.table_headers = data?.table_headers ?? [];
    this.table_rows = data?.table_rows ?? [];
  }

  static getDefault(): BehaviorAssistantRationaleWorkSchedule {
    return new BehaviorAssistantRationaleWorkSchedule({
      table_headers: [],
      table_rows: [],
    });
  }

  /**
   * Convert this object into pdfmake body format
   */
  toPdfBody(): BehaviorAssistantRationalePdfCell[][] {
    return [this.table_headers, ...this.table_rows];
  }
}
